<script>
export default {
  name: 'SentToEducator',
  props: {
    isMobile: { type: Boolean, default: false },
    classificationName: { type: String, default: '' },
  },
}
</script>

<template>
  <div class="d-flex align-center sent-to-educator-wrapper">
    <v-icon size="20" class="rounded-full sent-to-educator">mdi-update</v-icon>

    <div v-if="isMobile" class="d-flex flex-column text-start">
      <span class="sent-to-educator-text ml-2">{{
        $t('bookingList.sentToEducator')
      }}</span>
      <span class="ml-2"> {{ classificationName }}</span>
    </div>

    <span v-else class="sent-to-educator-text pl-2">{{
      $t('bookingList.sentToEducator')
    }}</span>
  </div>
</template>

<style lang="scss" scoped>
@import '@/styles/_colors.scss';
.sent-to-educator-wrapper {
  .sent-to-educator {
    width: 32px;
    height: 32px;
    background-color: $color-neutral-grey-200;
    border-radius: 100%;

    .v-icon {
      color: $color-gray-550;
    }
  }

  .sent-to-educator-text {
    padding-top: 1px;
    font-weight: 400;
    line-height: normal;
    color: $color-gray-600;
  }
}
</style>
